import React, { } from 'react'
import { Button, Cascader, DatePicker, Form, Input, InputNumber, Radio, Select } from 'antd'
import { DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import { CounterTitle, HorizontalFormWrapper } from '../dashboard.styled'
import { useTranslation } from 'react-i18next'
import { operatorConf } from '../Conf'
import { DataType } from '../../../constants/DataType'

function Filter (props) {
  const { form, defPlaceholder, defConfig, counter, handleDelCounter, handleAddCounter, crossData, filterOpt, columnMapping, hideFilterLogic, uniqueKey, maxFilter, disableActions, viewOnly } = props
  const { t: ln_t } = useTranslation()
  const formVal = Form.useWatch() || {}

  const logicOptions = [{ value: 'AND', label: ln_t('dashboard.and') }, { value: 'OR', label: ln_t('dashboard.or') }]
  const operatorOpt = operatorConf(ln_t)

  const componentProps = { showSearch: true, options: filterOpt }
  const SelectComponent = (props) => crossData ? <Cascader {...componentProps} {...props} expandTrigger='hover' /> : <Select {...componentProps} {...props} optionFilterProp='children' />
  const valueComponent = {
    input: props => <Input {...props} />,
    inputNumber: props => <InputNumber {...props} style={{ width: '100%' }} />,
    inputMultiple: props => <Select
      dropdownRender={menu => <><span style={{ display: 'none' }}>{menu}</span> <div style={{ color: 'rgba(0,0,0,.4)', padding: '2px 8px' }}>{ln_t('dashboard.inputMultipleInfo')}</div></>}
      mode="tags"
      {...props} />,
    datepicker: props => <DatePicker {...props} style={{ width: '100%' }} />,
    rangepicker: props => <DatePicker.RangePicker {...props} style={{ width: '100%' }} />
  }
  return (
    <>
      {counter?.length > 0 && !hideFilterLogic &&
        <Form.Item {...defConfig('filterLogic', 'select')} initialValue="AND" name={`${uniqueKey ? `${uniqueKey}-` : ''}filterLogic`}>
          <Radio.Group options={logicOptions} optionType="button" buttonStyle="solid" />
        </Form.Item>}
      {counter?.map(num => {
        const key = uniqueKey ? `${uniqueKey}-${num}` : num
        const selectedCol = Array.isArray(formVal?.[`${key}-column`]) ? formVal?.[`${key}-column`]?.join('^@^') : formVal?.[`${key}-column`]
        const arrLength = formVal?.[`${key}-column`]?.length
        const isDate = Array.isArray(formVal?.[`${key}-column`]) ? formVal?.[`${key}-column`]?.[arrLength - 1] === 'm' || formVal?.[`${key}-column`]?.[arrLength - 1] === 'd' : false
        const selectedColType = isDate ? DataType.DATE : columnMapping[selectedCol]?.type
        const operatorOptions = operatorOpt[selectedColType] || []
        const { component, time } = operatorOptions?.find(i => i.value === formVal?.[`${key}-operator`]) || {}
        const valComponent = valueComponent[component] || valueComponent.input
        return <React.Fragment key={key}>
          <CounterTitle>
            {ln_t('dashboard.filter')} #{num}
            {!disableActions && <DeleteTwoTone style={{ cursor: 'pointer' }} twoToneColor="#707070" onClick={() => handleDelCounter(num)} />}
          </CounterTitle>
          <HorizontalFormWrapper>
            <Form.Item name={`${key}-column`} rules={[{ required: true, message: defPlaceholder('column', 'select') }]}>
              {SelectComponent({ placeholder: defPlaceholder('column', 'select'), onChange: () => form.setFieldsValue({ [`${key}-operator`]: undefined, [`${key}-value`]: undefined }) })}
            </Form.Item>
            <Form.Item name={`${key}-operator`} rules={[{ required: true, message: defPlaceholder('operator', 'input') }]}>
              <Select
                showSearch
                options={operatorOptions}
                placeholder={defPlaceholder('operator', 'input')}
                onChange={() => form.setFieldValue(`${key}-value`, undefined)}
                optionFilterProp="children"
                disabled={!formVal?.[`${key}-column`] || viewOnly} />
            </Form.Item>
            <Form.Item name={`${key}-value`} rules={[{ required: true, message: defPlaceholder('value', 'input') }]}>
              {valComponent?.({ placeholder: defPlaceholder('value', 'input'), disabled: !formVal?.[`${key}-operator`] || viewOnly, ...time ? { showTime: time } : {} })}
            </Form.Item>
          </HorizontalFormWrapper>
        </React.Fragment>
      })}
      {(!maxFilter || counter.length < maxFilter) && !disableActions
        ? <Button type="default" style={{ width: '100%', marginTop: '8px' }} icon={<PlusOutlined />} onClick={handleAddCounter}>
            {ln_t('util.add')} {ln_t('dashboard.filter')}
          </Button>
        : ''}
    </>
  )
}

export default Filter
